import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-218" data-mp="1d0cp9qc68bfb">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-219" data-mp="1rqbj5gwp10oz" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-220" data-mp="1mtbdv87o41yx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-221" data-mp="z2fsotxpw50n">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-222" data-mp="1822rd7z2awq0">
            <span className="text-2xl" data-id="element-223" data-mp="13zy20lfncm96">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-224" data-mp="142k8siupqxqc">
            Introducing the Complete System
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-225" data-mp="2fg5v7w96ul86">
            Food Science Teacher Ready™
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-226" data-mp="2bunr7nyyci5r">
            90 Ready-to-Teach Lessons · 5 Strategic Bonuses · Everything Ready
            to Use From Today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-227" data-mp="2kxoulgwfnv5q">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-228" data-mp="2pw057tujy9p0">
            {['This is not a collection of random worksheets pulled from the internet.', 'This is not a theoretical textbook you have to rewrite before it works in a real classroom.', 'This is not content designed for a different type of teacher that you have to completely adapt.'].map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-229" data-mp="1efjkbl08b0ur">
                <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-230" data-mp="2hr8rkw3jx2hb" />
                <p className="text-gray-400 text-sm" data-id="element-231" data-mp="2hpe5hegjn4bn">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-232" data-mp="2qjj4il5tzm29">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-233" data-mp="1yswhn84tfoko" />
            <div className="flex items-start gap-3 relative z-10" data-id="element-234" data-mp="1tuurk38z2ozp">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-235" data-mp="27tb62gd2tjse" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-236" data-mp="22tyb18c1x6eq">
                This is a complete professional teaching library — so you walk
                into every class fully prepared, confident, and ready to deliver
                a lesson your students will actually feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}